import type { FlexContainerProps } from '@/components/atomic/atoms/layout/flex-container/typings';
import View from '@/components/atomic/atoms/layout/view/styled';
import type { BasicComponentProps } from '@/typings/generic';
import { generateStylesheetRules } from '@/utils/generate-stylesheet-rules';
import styled, { CSSObject } from '@emotion/styled';

const FlexContainer = styled(View)<FlexContainerProps & BasicComponentProps>(({
	$gap,
	$alignItems,
	$justifyContent,
	$flexDirection,
	$breakpoints,
	$flexWrap,
	$rowGap,
	$columnGap,
	$background,
	$visibility,
	$opacity,
}) => {
	const flexContainerProps = {
		$alignItems,
		$justifyContent,
		$flexDirection,
		$flexWrap,
		$rowGap,
		$columnGap,
		$background,
		$visibility,
		$opacity,
	};

	const style: CSSObject = {
		...generateStylesheetRules(
			flexContainerProps,
			Object.keys(flexContainerProps),
		),
		display: 'flex',
	};

	if ($gap !== undefined) style.gap = `${$gap}px`;

	if ($breakpoints !== undefined) {
		Object.entries($breakpoints).forEach(([breakpoint, props]) => {
			const breakpointKey = `@media (min-width: ${breakpoint}px)`;

			const nestedStyle: CSSObject = generateStylesheetRules(
				props,
				Object.keys(props),
			);

			if (!style[breakpointKey]) style[breakpointKey] = nestedStyle;

			if (props.$gap !== undefined) nestedStyle.gap = `${props.$gap}px`;
		});
	}

	return style;
});

export default FlexContainer;
